import { useQuery } from "@tanstack/react-query";
import type { SeatShape } from "../../components/SeatMap/seatPositions";
import { apiGet } from "../../lib/api-client";

export interface Seat {
  seatId: number;
  label: string;
  isActive: boolean;
  xPercent?: number;
  yPercent?: number;
  widthPercent?: number;
  heightPercent?: number;
  area?: string;
  shape?: SeatShape;
  createdAt: string;
  updatedAt: string;
}

interface SeatsResponse {
  seats: Seat[];
}

export function useSeats() {
  return useQuery({
    queryKey: ["seats"],
    queryFn: async () => {
      const response = await apiGet<SeatsResponse>("/seats");
      return response.seats;
    },
  });
}
